module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Envio da documentação concluída","description":"O documento enviado será analisado pela nossa equipe em até 1 dia útil.","button":"Ir para contestações"},"en-US":{"title":"Documentation sent","description":"The document sent will be analyzed by our team within 1 business day.","button":"Go to disputes"}}')
  delete Component.options._Ctor
}
